import CanadaPostStrikeCheckoutMessage from 'components/SharedComponents/CanadaPostStrike/CanadaPostStrikeCheckoutMessage/CanadaPostStrikeCheckoutMessage';
import { withCanadaPostStrikeCheckoutMessageProps } from 'components/SharedComponents/CanadaPostStrike/CanadaPostStrikeCheckoutMessage/withCanadaPostStrikeCheckoutMessageProps';

export default withCanadaPostStrikeCheckoutMessageProps(CanadaPostStrikeCheckoutMessage);
